import { render, staticRenderFns } from "./AssessmentStatusCheckbox.vue?vue&type=template&id=62cd9f3e&scoped=true"
import script from "./AssessmentStatusCheckbox.vue?vue&type=script&lang=js"
export * from "./AssessmentStatusCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AssessmentStatusCheckbox.vue?vue&type=style&index=0&id=62cd9f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd9f3e",
  null
  
)

export default component.exports